import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

export const RichTextIcon: FunctionComponent<SvgIconProps> = (props) => (
	<SvgIcon
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			clipRule="evenodd"
			d="M3 21H21V19H3V21ZM3 17H21V15H3V17ZM12 13H21V11H12V13ZM12 9H21V7H12V9ZM12 3V5H21V3H12ZM10.6 3H3V5.6H5.5L5.6 13H8.1L8 5.6H10.5V3H10.6Z"
			fill="#79818F"
			fillRule="evenodd"
		/>
	</SvgIcon>
);

export default RichTextIcon;
